angular.module('routes.import.ImportController', [
])

/**
 * The ImportController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class ImportController
 * @constructor
 * @module routes.import.ImportController
 */
.controller('ImportController', [
  '$scope',
  '$state',
  'CasesService',
  function ($scope, $state, CasesService) {
    'use strict';

    $scope.state = $state;

    $scope.cases = {
      current: null,
      list: []
    };

    /**
     * Method sets case data from Model
     *
     * @private
     */
    function defineCaseList() {
      $scope.cases.list = CasesService.get();
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineCaseList();
    }
    initialize();
  }
]);
